/** @format */

import axios from "axios";
import { apiInstanceFetch } from "../../../util/api";
import { setToast } from "../../../util/toast";
import * as ActionType from "./condition.type";

export const getCondition = () => (dispatch) => {
	apiInstanceFetch
		.get(`condition/getCondition`)
		.then((res) => {
			dispatch({
				type: ActionType.GET_CONDITION,
				payload: res.data,
			});
		})
		.catch((error) => console.error(error));
};

export const addCondition = (payload) => (dispatch) => {
	axios.post(`condition/createCondition`, payload)
		.then((res) => {
			if (res.data.status === true) {
				dispatch({ type: ActionType.CREATE_CONDITION, payload: res.data.data });
				setToast("success", "Condition created Successfully !");
			} else {
				setToast("error", res.data.message || "Could not create condition");
			}
		})
		.catch((error) => console.error(error));
};

export const updateCondition = (payload, id) => (dispatch) => {
	axios.patch(`condition/updateCondition?conditionId=${id}`, payload)
		.then((res) => {
			if (res.data.status === true) {
				dispatch({ type: ActionType.UPDATE_CONDITION, payload: res.data.data });
				setToast("success", "Condition updated Successfully !");
			} else {
				setToast("error", res.data.message || "Could not update condition");
			}
		})
		.catch((error) => console.error(error));
};

export const toggleConditionActive = (id) => (dispatch) => {
	axios.patch(`condition/toggleActive?conditionId=${id}`)
		.then((res) => {
			if (res.data.status === true) {
				dispatch({ type: ActionType.UPDATE_CONDITION, payload: res.data.data });
				setToast("success", "Condition status updated");
			}
		})
		.catch((error) => console.error(error));
};

export const deleteCondition = (id) => (dispatch) => {
	axios.delete(`condition/deleteCondition?conditionId=${id}`)
		.then((res) => {
			if (res.data.status === true) {
				dispatch({ type: ActionType.DELETE_CONDITION, payload: id });
				setToast("success", "Condition deleted Successfully !");
			}
		})
		.catch((error) => console.error(error));
};
